/* eslint-disable no-case-declarations */
// There is a reducer for the Event Tester because it is unsafe to pass
// event data to the Event Tester through URL parameters. Thus, we must
// pass state through another mechanism (in this case, Redux state)
import { Reducer } from "redux";

export type EventTesterState = {
  event: object | null | undefined;
  eventDefID: string | null | undefined;
};

export const initialEventTesterState = {
  event: null,
  eventDefID: null,
};

// Actions
export const SET_EVENT_TESTER_DATA = "SET_EVENT_TESTER_DATA";

type SetEventDataAction = {
  type: typeof SET_EVENT_TESTER_DATA;
  payload: EventTesterState;
};

type EventTesterActions = SetEventDataAction;

const eventTesterReducer: Reducer<EventTesterState, EventTesterActions> = (
  state = initialEventTesterState,
  action
): EventTesterState => {
  switch (action.type) {
    case SET_EVENT_TESTER_DATA:
      return action.payload;
    default:
      return state;
  }
};

export default eventTesterReducer;
